import script from "./DataObjectDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataObjectDetail.vue?vue&type=script&lang=ts&setup=true"

import "./DataObjectDetail.vue?vue&type=style&index=0&id=b2fd6cee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2fd6cee"]])

export default __exports__